export default {
  apiKey: 'AIzaSyCcqnQ-x3Ogm6MAr7RHAKlstuLC5k-E0Wg',
  authDomain: 'prod-cw-red.firebaseapp.com',
  databaseURL: 'https://prod-cw-red.firebaseio.com',
  projectId: 'prod-cw-red',
  storageBucket: 'prod-cw-red.appspot.com',
  messagingSenderId: '415911175105',
  appId: '1:415911175105:web:35bd15d64b7426d2fe4540',
  measurementId: 'G-YLRXS8VX0N',
};
